<div class="splide" id="plans">
  <div class="splide__track">
    <ul class="splide__list">
      <li class="splide__slide" *ngFor="let plan of plans">
        <mat-card [ngClass]="{ selected: plan.selected === true }">
          <mat-card-header>
            <mat-card-title>{{ plan.title }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="desconto" *ngIf="plan.descont">
              <span>({{ plan.descont }})</span>
            </div>
            <div class="price">
              <span class="mat-display-1 details">R$</span>
              <span class="mat-display-4 value">{{
                getPriceValue(plan.price)
              }}</span>
              <span class="mat-display-1 details"
                >,{{ getPriceDetails(plan.price) }}</span
              >
            </div>
          </mat-card-content>
          <mat-card-actions>
            <button
              mat-raised-button
              class="custom-primary"
              color="default"
              style="width: 100%"
              (click)="selectPlan(plan)"
            >
              {{ !plan.selected ? "Escolher" : "Selecionado" }}
            </button>
          </mat-card-actions>
        </mat-card>
      </li>
    </ul>
  </div>
</div>
